import produce from 'immer';

import { RESET_USER_STATE } from '../../Main/constants';
import {
  CHANGE_ALERT_FORM,
  CHANGE_PAPERLESS_FORM,
  CHANGE_STEP,
  CLOSE_MODAL_STATE,
  FETCH_ALERT_SETTINGS,
  FETCH_ALERT_SETTINGS_FAILURE,
  FETCH_ALERT_SETTINGS_SUCCESS,
  FETCH_PAPERLESS_SETTING_ALL,
  FETCH_PAPERLESS_SETTING_ALL_FAILURE,
  FETCH_PAPERLESS_SETTING_ALL_SUCCESS,
  OPEN_MODAL_STATE,
  PUT_ALERT_SETTINGS,
  PUT_ALERT_SETTINGS_FAILURE,
  PUT_ALERT_SETTINGS_SUCCESS,
  PUT_PAPERLESS_SETTING,
  PUT_PAPERLESS_SETTING_FAILURE,
  PUT_PAPERLESS_SETTING_SUCCESS,
  RESET_FORM_STATE,
  RESET_STATUS_STATE,
  SET_SELECTED_LOAN,
} from './constants';
import { getFormPaperlessSettings } from './helpers';

export const initialState = {
  alertsProfile: {},
  currentAlertSettings: [],
  currentPaperlessSettings: {},
  errors: { alerts: false, paperless: false },
  formAlertSettings: [],
  formPaperlessSettings: {},
  isModalOpen: false,
  modalState: '',
  requestStatus: {
    fetchAlertSettings: 'idle',
    fetchPaperlessSettingAll: 'idle',
    putAlertSettings: 'idle',
    putPaperlessSetting: 'idle',
  },
  selectedLoan: '',
  step: 1,
};

/* eslint-disable consistent-return, default-case, no-param-reassign */
const communicationsReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_ALERT_FORM: {
      const { alertId: targetAlertId, field } = payload;
      let newValue = false;
      const targetIndex = draft.formAlertSettings.findIndex((alertObj) => {
        const { alertId } = alertObj;
        if (alertId === targetAlertId) {
          newValue = !alertObj[field];
          return true;
        }
        return false;
      });
      draft.formAlertSettings[targetIndex][field] = newValue;
      break;
    }
    case CHANGE_PAPERLESS_FORM: {
      const { loanNumber } = payload;
      const targetObj = draft.formPaperlessSettings[loanNumber];
      targetObj.status = targetObj.status === 'Enabled' ? 'Not_Enabled' : 'Enabled';
      break;
    }
    case CHANGE_STEP: {
      const { step } = payload;
      draft.step = step;
      break;
    }
    case CLOSE_MODAL_STATE: {
      draft.isModalOpen = initialState.isModalOpen;
      draft.modalState = initialState.modalState;
      break;
    }
    case FETCH_ALERT_SETTINGS: {
      draft.requestStatus.fetchAlertSettings = 'loading';
      break;
    }
    case FETCH_ALERT_SETTINGS_FAILURE: {
      const { error } = payload;
      draft.errors.alerts = error;
      draft.requestStatus.fetchAlertSettings = 'failed';
      break;
    }
    case FETCH_ALERT_SETTINGS_SUCCESS: {
      const { currentSetting, profile } = payload;
      draft.alertsProfile = profile;
      draft.currentAlertSettings = currentSetting;
      draft.formAlertSettings = currentSetting;
      draft.requestStatus.fetchAlertSettings = 'succeeded';
      break;
    }
    case FETCH_PAPERLESS_SETTING_ALL: {
      draft.requestStatus.fetchPaperlessSettingAll = 'loading';
      break;
    }
    case FETCH_PAPERLESS_SETTING_ALL_FAILURE: {
      const { error } = payload;
      draft.errors.paperless = error;
      draft.requestStatus.fetchPaperlessSettingAll = 'failed';
      break;
    }
    case FETCH_PAPERLESS_SETTING_ALL_SUCCESS: {
      const { currentPaperlessSettings } = payload;
      /*
        TODO: Determine if (and how) we should handle partial errors here.
              Currently, they're being stored in their respective hashed loan
              number objects within currentPaperlessSettings. It's likely that
              partial errors don't need to be handled because we can just use
              the status returned.
      */
      draft.currentPaperlessSettings = currentPaperlessSettings;
      draft.formPaperlessSettings = getFormPaperlessSettings(currentPaperlessSettings);
      draft.requestStatus.fetchPaperlessSettingAll = 'succeeded';
      break;
    }
    case OPEN_MODAL_STATE: {
      const { modalState } = payload;
      draft.isModalOpen = true;
      draft.modalState = modalState;
      break;
    }
    case PUT_ALERT_SETTINGS: {
      draft.requestStatus.putAlertSettings = 'loading';
      break;
    }
    case PUT_ALERT_SETTINGS_FAILURE: {
      const { error } = payload;
      draft.errors.alerts = error;
      draft.requestStatus.putAlertSettings = 'failed';
      break;
    }
    case PUT_ALERT_SETTINGS_SUCCESS: {
      draft.requestStatus.putAlertSettings = 'succeeded';
      break;
    }
    case PUT_PAPERLESS_SETTING: {
      draft.requestStatus.putPaperlessSetting = 'loading';
      break;
    }
    case PUT_PAPERLESS_SETTING_FAILURE: {
      const { error } = payload;
      draft.errors.paperless = error;
      draft.requestStatus.putPaperlessSetting = 'failed';
      break;
    }
    case PUT_PAPERLESS_SETTING_SUCCESS: {
      draft.requestStatus.putPaperlessSetting = 'succeeded';
      break;
    }
    case RESET_FORM_STATE: {
      draft.errors = initialState.errors;
      draft.formAlertSettings = draft.currentAlertSettings;
      draft.formPaperlessSettings = draft.currentPaperlessSettings;
      draft.selectedLoan = initialState.selectedLoan;
      draft.step = initialState.step;
      break;
    }
    case RESET_STATUS_STATE: {
      const { statusKeys } = payload;
      if (!statusKeys) {
        draft.requestStatus = initialState.requestStatus;
      } else {
        statusKeys.forEach((key) => {
          draft.requestStatus[key] = initialState.requestStatus[key];
        });
      }
      break;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_SELECTED_LOAN: {
      const { loanNumber } = payload;
      draft.selectedLoan = loanNumber;
      break;
    }
  }
}, initialState);

export default communicationsReducer;
